import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useGetCampaignQuery } from "@/api/CampaignApi.ts";
import Loader from "@/components/Loader.tsx";
import { ElementNotFound } from "@/components/errors/ElementNotFound.tsx";
import { CampaignContext } from "@contexts/CampaignContext.tsx";
import CampaignSummaryCard from "@components/campaigns/CampaignSummaryCard.tsx";
import { Stack } from "@mui/material";

export const Route = createFileRoute("/_dashboard/campaigns/$uuid")({
  beforeLoad: ({ params, location }) => {
    if (location.pathname === `/campaigns/${params.uuid}`) {
      throw redirect({
        to: "/campaigns/$uuid/$tab",
        params: { uuid: params.uuid, tab: "overview" },
      });
    }
  },
  component: CampaignRouteLayout,
});

function CampaignRouteLayout() {
  const { uuid } = Route.useParams();
  const { data, isLoading } = useGetCampaignQuery(uuid);

  if (isLoading) return <Loader />;
  if (!data) return <ElementNotFound />;

  return (
    <CampaignContext.Provider value={data}>
      <Stack spacing={2}>
        <CampaignSummaryCard campaign={data} />
        <Outlet />
      </Stack>
    </CampaignContext.Provider>
  );
}
